var map = {
	"./cs": 2316,
	"./cs.json": 2316,
	"./en": 846,
	"./en.json": 846,
	"./sk": 5697,
	"./sk.json": 5697
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5430;
module.exports = webpackAsyncContext;